/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../_asset/sources/assets/styles/@scss/bsp.base.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './components/GNB/header/header.component.ngfactory';
import * as i3 from '../../app/components/GNB/header/header.component';
import * as i4 from '@angular/router';
import * as i5 from '../../app/shared/services/src/app.services';
import * as i6 from '@ngx-translate/core/src/translate.service';
import * as i7 from '../../app/shared/services/src/api/common.services';
import * as i8 from '../../app/shared/services/src/api/team.services';
import * as i9 from 'angular-2-local-storage/dist/local-storage.service';
import * as i10 from '../../app/shared/services/src/env.services';
import * as i11 from '../../app/shared/authentications/src/auth.services';
import * as i12 from '../../app/shared/services/src/keycloaklogin.service';
import * as i13 from '../../app/shared/services/src/integrated.keycloaklogin.service';
import * as i14 from '../../app/env-load/env-load.service';
import * as i15 from './components/GNB/footer/footer.component.ngfactory';
import * as i16 from '../../app/shared/services/src/scriptService';
import * as i17 from '../../app/shared/services/src/api/agreement.services';
import * as i18 from '@angular/http';
import * as i19 from '../../app/components/GNB/footer/footer.component';
import * as i20 from '@angular/platform-browser';
import * as i21 from '@angular/common';
import * as i22 from './components/msg-popup/msg-popup.component.ngfactory';
import * as i23 from '../../app/components/msg-popup/msg-popup.component';
import * as i24 from '../../app/shared/utils/src/customHttp/pubsubservice';
import * as i25 from '../../app/shared/services/src/msg-popup.service';
import * as i26 from '@angular/common/http';
import * as i27 from '../../app/app.component';
import * as i28 from '../../app/shared/services/src/login.service';
import * as i29 from '../../app/shared/services/src/api/guide.services';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
function View_AppComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-main-header',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_HeaderComponent_0,
      i2.RenderType_HeaderComponent)),i1.ɵdid(1,2867200,(null as any),0,i3.HeaderComponent,
      [i4.Router,i5.AppServices,i6.TranslateService,i7.CommonServices,i8.TeamServices,
          i9.LocalStorageService,i10.EnvServices,i11.AuthServices,i10.EnvServices,
          i12.KeycloakloginService,i13.IntegratedKeycloakloginService,i14.EnvLoadService],
      {loginUser:[0,'loginUser'],curLang:[1,'curLang']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.loginUser;
    const currVal_1:any = _co.userLang;
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_AppComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵand(0,(null as any),(null as any),
          0))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
function View_AppComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'app-main-footer',
      ([] as any[]),(null as any),(null as any),(null as any),i15.View_FooterComponent_0,
      i15.RenderType_FooterComponent)),i1.ɵprd(512,(null as any),i16.ScriptService,
      i16.ScriptService,[i10.EnvServices]),i1.ɵprd(512,(null as any),i17.AgreementServices,
      i17.AgreementServices,[i18.Http]),i1.ɵdid(3,114688,(null as any),0,i19.FooterComponent,
      [i6.TranslateService,i16.ScriptService,i7.CommonServices,i20.DomSanitizer,i10.EnvServices,
          i14.EnvLoadService,i17.AgreementServices],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,3,0);
      },(null as any));
}
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),16,'div',[['class',
      'layout-wrap']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_AppComponent_1)),i1.ɵdid(3,16384,(null as any),
          0,i21.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_AppComponent_2)),i1.ɵdid(7,16384,(null as any),0,i21.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_AppComponent_3)),i1.ɵdid(10,16384,(null as any),0,i21.NgIf,[i1.ViewContainerRef,
          i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['\n\n    '])),(_l()(),i1.ɵeld(12,0,(null as any),(null as any),1,'msg-popup',
          ([] as any[]),(null as any),(null as any),(null as any),i22.View_MsgPopupComponent_0,
          i22.RenderType_MsgPopupComponent)),i1.ɵdid(13,114688,(null as any),0,i23.MsgPopupComponent,
          [i24.PubSubService,i25.MsgPopupService,i4.Router,i26.HttpClient,i12.KeycloakloginService,
              i13.IntegratedKeycloakloginService,i14.EnvLoadService],(null as any),
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(15,
          0,(null as any),(null as any),0,'div',([] as any[]),[[2,'spinner',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n\n']))],(_ck,
      _v) => {
    var _co:i27.AppComponent = _v.component;
    const currVal_0:any = _co.loading;
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = _co.loading;
    _ck(_v,7,0,currVal_1);
    const currVal_2:any = _co.loading;
    _ck(_v,10,0,currVal_2);
    _ck(_v,13,0);
  },(_ck,_v) => {
    var _co:i27.AppComponent = _v.component;
    const currVal_3:boolean = !_co.loading;
    _ck(_v,15,0,currVal_3);
  });
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵprd(512,(null as any),i28.LoginService,i28.LoginService,[i18.Http]),i1.ɵdid(2,
          114688,(null as any),0,i27.AppComponent,[i6.TranslateService,i7.CommonServices,
              i24.PubSubService,i4.Router,i8.TeamServices,i9.LocalStorageService,i5.AppServices,
              i28.LoginService,i10.EnvServices,i14.EnvLoadService,i29.GuideServices,
              i12.KeycloakloginService,i13.IntegratedKeycloakloginService,i25.MsgPopupService,
              i11.AuthServices],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i27.AppComponent> = i1.ɵccf('app-root',
    i27.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/aot/app/app.component.ngfactory.ts